
let lookupByType, chosen_accounts;
let n = 0;

$('#tppform').on('submit', function (event) {
	event.preventDefault();
});

$('input[type=radio][name=optlookupBy]').change(function () {
	$('#nextBtn').attr('disabled', false);
	$('#nextBtn').removeClass('btn-secondary');
	$('#nextBtn').addClass('btn-primary');
	setLookupByType();
});

let currentTab = 0; 
const lastTab = 4;

showTab(currentTab); 

function showTab(n) {
	let x = document.getElementsByClassName('tab');
	x[n].style.display = 'block';
	if (n == 0) {
		document.getElementById('prevBtn').style.display = 'none';
	} else {
		document.getElementById('prevBtn').style.display = 'inline';
	}
	if (n == 2) {
		$('#nextBtn').addClass('d-none').attr('aria-hidden', 'true');
		$('#btnSubmit').removeClass('d-none').attr('aria-hidden', 'false');

	} else {
		document.getElementById('nextBtn').innerHTML = 'Next <i class="fas fa-caret-right"></i>';
	}
	fixStepIndicator(n);
}

function nextPrev(n, ip_addr) {

	let tab = document.getElementsByClassName('tab');

	document.getElementsByClassName('step')[currentTab].className += ' finish';

	tab[currentTab].style.display = 'none';

	currentTab = currentTab + n;

	if (currentTab !== lastTab) {

		document.getElementsByClassName('step')[currentTab].className += ' finish';

		if (ip_addr !== undefined) {
			verifySession(ip_addr)
				.then(function (result) {
					consoleErrorIfTestMode(result);
				})
				.catch((error) => {
					consoleErrorIfTestMode(error);
				});
		}
	}

	switch (tab[currentTab].id) {
		case 'tabFindAccounts':
			switch (lookupByType) {
				case 'findby-name':
					$('.grid-card-text').text('If you cannot find your business by account name, please broaden your search.');
					break;
				case 'findby-number':
					$('.grid-card-text').text('If you cannot find your business by Account Number, please return to the previous step and try searching by Account Name.');
					break;
				default:
					$('.grid-card-text').text('');
			}

			$('#nextBtn').removeClass('d-none').attr('aria-hidden', 'false');
			$('#btnSubmit').addClass('d-none').attr('aria-hidden', 'true');

			addLookupListenter();
			break;

		case 'tabCheckedAccounts':

			$('.card-title-chosen').innerHTML = 'Review';
			$('.card-text-chosen').innerHTML = '';

			populateCheckedAccounts();

			let forms = document.getElementsByClassName('needs-validation');
			let validation = Array.prototype.filter.call(forms, function (form) {
				form.addEventListener('submit', function (event) {
					checkEmail().then(function (result) {
						if (form.checkValidity() === false) {

							event.preventDefault();
							event.stopPropagation();
							form.classList.add('was-validated');

						} else {

							event.preventDefault();
							event.stopImmediatePropagation();

							$('#prevBtn').attr('disabled', true);
							$('#prevBtn').addClass('d-none').attr('aria-hidden', 'true');

							$('#nextBtn').attr('disabled', true);
							$('#nextBtn').addClass('d-none').attr('aria-hidden', 'true');

							$('#btnSubmit').attr('disabled', true);
							$('#btnSubmit').addClass('d-none').attr('aria-hidden', 'true');
							$('#btnSubmit').removeClass('submit-ready');

							let signature = $('#inputFilerName').val();

							doInserts()
								.then(function (result) {
									if (result) {
										if (result['RowCount'] > 0) {
											let emailValidatedState = result['EmailValidatedState'];
											doSendmail(result)
												.then((result) => {
													doSummary(result, emailValidatedState);
												})
												.catch((error) => {
													consoleErrorIfTestMode(error);
												});
										}
									}
								})
								.then(resetForm);
						}
					});
				}, false);
			});
			break;
		case 'tabSummary':
			break;
	}
	showTab(currentTab);
}

function verifySession(ip_addr) {

	return new Promise(function (resolve, reject) {

		let referrer = {
			ip_addr: ip_addr,
			token: $('input:hidden[id=pao_token]').val()
		};
		let json = JSON.stringify(referrer);

		$.ajax({
			url: paoDetails.context.child_uri + '/models/pao-session.php',
			type: 'POST',
			data: { 'Request': json, 'protect': 'tpp_extension' },
			dataType: 'json',
			cache: false,
			timeout: 20000,
			error: function (xhr, ajaxOptions, thrownError) {
				let err = (!xhr.responseText === 'undefined' ? xhr.responseText + ', ' : '') + thrownError;
				consoleErrorIfTestMode(err);
				reject(true);
			},
			success: function (data) {

				if (data && data['tpp_extension']['token'] !== undefined) {

					$('<input>')
						.attr('type', 'hidden')
						.attr('id', 'pao_token')
						.appendTo('#tppform')
						.val(data['tpp_extension']['token']);

				}
				if (data && data['tpp_extension']['auth'] !== undefined) {
					consoleErrorIfTestMode(data['tpp_extension']['auth']);
				}



				resolve(true);
			}
		}); 
	}); 
}

function doSendmail(data) {

	return new Promise(function (resolve, reject) {

		let filer = $('#inputFilerName').val();
		let to = $('#inputEmail').val();

		let accountData = [];

		let d = chosen_accounts;
		$.each(d, function (index, item) {
			accountData.push(item['account']);
		});

		let mail = {
			filer: filer,
			to: to,
			token: $('input:hidden[id=pao_token]').val(),
			accounts: accountData,
			validated: data['EmailValidatedState']
		};

		let json = JSON.stringify(mail);

		$.ajax({
			url: paoDetails.context.child_uri + '/models/pao-model-tpp-mail.php',
			type: 'POST',
			data: { 'Request': json },
			dataType: 'json',
			cache: false,
			timeout: 10000,
			error: function (xhr, ajaxOptions, thrownError) {
				let err = (!xhr.responseText === 'undefined' ? xhr.responseText + ', ' : '') + thrownError;
				consoleErrorIfTestMode(err);
				reject(true);
			},
			success: function (data) {
				resolve(data);
			}
		}); 
	}); 
}

function resetForm(data) {
	return new Promise(function (resolve, reject) {
		document.getElementById('tppform').reset();
		resolve(data);
	}); 
}

function doSummary(data, emailValidatedState) {

	return new Promise(function (resolve, reject) {

		let to = $('#inputEmail').val();

		if (data['Success'] === true) {

			nextPrev(1, '');

			let validationMessage = '';

			if (emailValidatedState === 'EmailIsNotValidated') {
				validationMessage = '<p>Requesting a TPP 30 Day Extension requires you to confirm your email address, look for the verification email in your inbox and click the link in that email. A confirmation message will appear in your web browser. If you do not receive the confirmation message, please check your Junk email folder. Should you have any problems with receiving the email, please contact the Tangible Personal Property Department at: TPP@ManateePAO.gov or call 941-748-8208.</p><br />';
			}

			$('.card-title-summary').html('THIS IS YOUR CONFIRMATION NOTICE.');
			$('.card-text-summary').html(`<p>Your request for a 30 Day Extension has been received.</p> ${validationMessage}<p>Thank you.</p>`);

		} else {

			nextPrev(1, '');


			$('.card-title-summary').html('THIS IS YOUR CONFIRMATION NOTICE.');
			$('.card-text-summary').html(`<p>Your request for a 30 Day Extension has been received.</p>
			<p>Your request for an extension has been received, but we encountered an issue sending your confirmation notice to ${to}. Please contact our IT department at paoit@manateepao.gov
			to confirm that your request for a TPP 30 Day extension was received. We apologize for any inconvenience this may have caused.</p>`);

		}
		resolve(true);

	}); 
}

function doInserts() {

	return new Promise(function (resolve, reject) {

		let modal_msg = 'Please wait while we process your TPP 30 Day Extension request.<br />';
		modal_msg += 'Do not refresh this page or navigate away until the process is complete.<br />This should take just a few seconds.<br /><br />Thank you.';

		showModal('process', ' TPP 30 Day Extension Request - PROCESSING', modal_msg, false, false, false);

		let accountData = [];

		let d = chosen_accounts;
		$.each(d, function (index, item) {
			accountData.push(item['account']);
		});

		let obj = {
			job: 'account_inserts',
			accounts: accountData,
			email: $('#inputEmail').val(),
			signature: $('#inputFilerName').val() 
		};

		let json = JSON.stringify(obj);

		$.ajax({
			url: paoDetails.context.child_uri + '/models/pao-model-tpp-ins.php',
			type: 'POST',
			data: { 'Request': json },
			dataType: 'json',
			cache: false,
			timeout: 20000,
			error: function (xhr, ajaxOptions, thrownError) {
				let err = (!xhr.responseText === 'undefined' ? xhr.responseText + ', ' : '') + thrownError;
				consoleErrorIfTestMode(err);
				reject(true);
			},
			success: function (data) {

				setTimeout(function () {
					$('#process_modal').modal('hide');
				}, 6000);

				if (data !== undefined) {
					resolve(data);
				} else {
					reject(true);
				}
			}
		}); 
	}); 
} 

function lookupAccount(lu_value) {

	let obj = {
		job: 'request_extension',
		findBy: lookupByType,
		findText: lu_value
	};

	let json = JSON.stringify(obj);

	$.ajax({
		url: paoDetails.context.child_uri + '/models/pao-model-tpp.php',
		type: 'POST',
		data: { 'Request': json },
		dataType: 'json',
		cache: false,
		timeout: 20000,
		error: function (xhr, ajaxOptions, thrownError) {
			let err = (!xhr.responseText === 'undefined' ? xhr.responseText + ', ' : '') + thrownError;
			$('#pageInfo').html('Search terminated. Reason: ' + err);
		},
		beforeSend: function () {
			$('#pageInfo').addClass('progressWorking');
			$('#pageInfo').html('Searching&nbsp;&nbsp;<i class="far fa-spinner-third fa-spin"></i>');
		},
		complete: function (jqXHR, textStatus) {
			$('#pageInfo').removeClass('progressWorking');
		},
		success: function (data) {
			loadAccounts(data);
		}
	});
}

function clearChecked() {

	let table = $('#tppAccounts').DataTable();
	table.rows(function (idx, data, node) {
		$(node).find('.dt-checkboxes:input[type="checkbox"]').prop("checked", function (i, val) {
			return false;
		});
	});

	$('#clearBtn').removeClass('clear-checked');
	$('#clearBtn').addClass('checked-cleared');

}

function loadAccounts(data) {

	$('#searchInfo').empty();
	$('#pageInfo').empty();

	$('#dgData').remove();
	$('#clearBtn').remove();
	$('#gridsearchBody').append(
		'<div id="dgData"><table id="tppAccounts" class="display table trans-font" cellspacing="0" width="100%" ></table></div>'
	);

	let button = document.createElement('button');
	button.setAttribute('id', 'clearBtn');
	button.setAttribute('type', 'button');
	button.className = 'btn btn-light btn-sm font-weight-bold d-none';
	button.setAttribute('aria-label', 'Click to unselect all');
	button.setAttribute('aria-hidden', 'true');
	button.textContent = 'Click to unselect all';
	button.addEventListener('click', clearChecked, false);

	$(button).insertAfter('#gridsearchBody');

	$('#dgData').show();
	$('#tppAccounts').DataTable({
		data: data.rows,
		columns: data.cols,
		columns: [
			{ title: 'Account' },
			{ title: 'Owner(s)' },
			{ title: 'Select to apply' }
		],
		columnDefs: [
			{
				targets: 0,
				width: '10%'
			},
			{
				targets: 1
			},
			{
				targets: 2,
				className: 'text-center',
				width: '15%',
				render: function (data, type, row, meta) {

					if (Boolean(row[2]) === Boolean(1)) { 
						data = '<span>Already Applied</span>'
					} else {
						data = '<input type="checkbox" class="dt-checkboxes">'
					}
					return data;
				},
				createdCell: function (td, cellData, rowData, row, col) {
					if (Boolean(rowData[2]) === Boolean(1)) {
						td.classList.add('applied');
					}
				}
			}
		],
		pageLength: 7,
		info: false,
		searching: false,
		lengthChange: false,
		drawCallback: function drawCallback(settings) {
			let api = this.api();
			let info = api.page.info();
			let $recordsMessage = info.recordsTotal >= 1000 ? 'Your search found more than 1,000 accounts. Only the first 1,000 will be shown.' : info.recordsTotal.toLocaleString() + ' accounts found in your search'; 

			$('#searchInfo').html($recordsMessage);
			$('#pageInfo').html('Showing accounts ' + (info.start + (info.recordsTotal >= 1 ? 1 : 0)) + ' to ' + info.end + ' for page ' + (info.page + (info.recordsTotal >= 1 ? 1 : 0)) + ' of ' + info.pages);

			let pagination = $(this).closest('.dt-container').find('.dt-paging');
			pagination.toggle(info.pages > 1);

			if (info.recordsTotal > 0) {
				$('.grid-card-text').text('Check all accounts that you wish to request for a 30 Day Extension.');
			} else {
				if (lookupByType === 'findby-number') {
					const pattern = /^[0-9]*$/gm;
					const regex = RegExp(pattern);
					let v = $('#lookup_account').val();
					if (!regex.test(v)) {
						$('.grid-card-text').text('Hmm, that appears to be an account name.');
					} else {
						$('.grid-card-text').text('No Companies In Our System Matched Your Search Criteria. Please Try Again.');
					}
				}
				$('#tppAccounts').remove();
			}
			if (info.pages > 1) {
				$('.select-help').text('Navigate the results using the Previous & Next paging buttons.');
			}

			$('#tppAccounts tbody').on('click', '.dt-checkboxes:input[type="checkbox"]', function () {
				let checkedCount = (getChecked()).length;
				if (checkedCount > 0) {
					$('#clearBtn').removeClass('checked-cleared');
					$('#clearBtn').addClass('clear-checked');
					$('#clearBtn').removeClass('d-none').attr('aria-hidden', 'false');
				} else {
					$('#clearBtn').removeClass('clear-checked');
					$('#clearBtn').addClass('d-none').attr('aria-hidden', 'true');
				}
			});

		}
	});
}

function showModal(id, title, message, showClose, showCancel, modButton, url) {

	let modal_id = id + '_modal';

	let modal_content = document.createElement('div');
	modal_content.setAttribute('id', modal_id + '_content');
	modal_content.className = 'modal-content';

	let div2 = document.createElement('div');
	div2.setAttribute('id', modal_id + '_header');
	div2.className = 'modal-header';

	let h = document.createElement('h5');
	h.setAttribute('id', modal_id + '_title');
	h.setAttribute('aria-labelledby', modal_id + '_title_label');
	h.innerHTML = "<i class=\"far fa-info-circle\"></i> " + title;
	h.setAttribute('aria-describedby', 'Message');
	h.className = 'modal-title pao-modal-title';
	div2.appendChild(h);

	let b = document.createElement('button');
	b.setAttribute('id', modal_id + '_btnclose');
	b.setAttribute('type', 'button');
	b.className = 'close';
	b.setAttribute('data-dismiss', 'modal');
	b.setAttribute('aria-label', 'Close');

	let s = document.createElement('span');
	s.setAttribute('id', modal_id + '_btnx');
	s.setAttribute('aria-hidden', 'true');
	s.innerHTML = '&times;';
	b.appendChild(s);

	div2.appendChild(b);
	modal_content.appendChild(div2);

	let div = document.createElement('div');
	div.setAttribute('id', modal_id + '_body');
	div.setAttribute('style', 'text-align:center;font-size:1.2rem;width:100%;border:0;');
	div.className = 'modal-body pao-modal-body';
	div.innerHTML = message;
	modal_content.appendChild(div);

	let modal_footer = document.createElement('div');
	modal_footer.setAttribute('id', modal_id + '_body');
	modal_footer.className = 'modal-footer';

	if (showClose) {

		div = document.createElement('button');
		div.setAttribute('id', modal_id + '_btncancel');
		div.setAttribute('type', 'button');
		div.setAttribute('id', 'btnRedirect');
		div.className = 'btn btn-secondary';
		div.setAttribute('data-dismiss', 'modal');
		div.setAttribute('aria-label', 'Cancel');
		div.innerHTML = 'Cancel';

		modal_footer.appendChild(div);

	} else if (showCancel) {

		div = document.createElement('button');
		div.setAttribute('id', modal_id + '_btncancel');
		div.setAttribute('type', 'button');
		div.setAttribute('id', 'btnRedirect');
		div.className = 'btn btn-secondary';
		div.setAttribute('data-dismiss', 'modal');
		div.setAttribute('aria-label', 'Cancel');
		div.innerHTML = 'Cancel';

		modal_footer.appendChild(div);
	}

	if (modButton) {
		modal_footer.appendChild(modButton);
	}

	modal_content.appendChild(modal_footer);

	let container = document.createElement('div');
	container.setAttribute('id', modal_id);
	container.setAttribute('tabindex', '-1');
	container.setAttribute('role', 'dialog');
	container.setAttribute('aria-hidden', 'true');
	container.className = 'modal fade pao-modal-message';

	let modal_diag = document.createElement('div');
	modal_diag.setAttribute('role', 'document');
	modal_diag.className = 'modal-dialog modal-lg';

	modal_diag.appendChild(modal_content);

	container.appendChild(modal_diag);

	let el = document.getElementById('modal_container');

	if (el) {
		el.appendChild(container);
		$('#' + modal_id).modal('show');
		$('#btnRedirect').on('click', {
			url: url
		}, doRedirect);

		$('#btnContinue').on('click', {
			url: url
		}, extendTime);

	}

} 

function extendTime() {
	event.stopPropagation();
}

function doRedirect(event) {
	document.location.href = event.data.url;
}

function setLookupByType() {
	let opt = $('input[name=optlookupBy]:checked');

	if (opt) {
		lookupByType = opt.val();
		$('.title-find-by').text('Enter your ' + opt[0].placeholder + ' in the field below.');
		$('.instructions').html('<i class="fas fa-arrow-alt-circle-right"></i> Click &quot;Next&quot; to retrieve your ' + opt[0].placeholder.toLowerCase() + ' and proceed to Step 2.');
	}
}

function populateCheckedAccounts() {

	let checked = getChecked();

	if (checked.length > 0) {
		$('div.g-recaptcha').removeClass('d-none').attr('aria-hidden', 'false');
		$('small.recaptcha-title').removeClass('d-none').attr('aria-hidden', 'false');

	} else {
		$('div.g-recaptcha').addClass('d-none').attr('aria-hidden', 'true');
		$('small.recaptcha-title').addClass('d-none').attr('aria-hidden', 'true');
	}

	chosen_accounts = checked.map((item) => {
		let account = {};
		account['account'] = item[0];
		account['onwer'] = item[1];
		account['signature'] = '';
		return account;
	});

	let html = [];

	if (chosen_accounts.length > 0) {
		let plural = chosen_accounts.length === 1 ? '' : 's';

		$('#inputFilerName').attr('disabled', false);
		$('#inputEmail').attr('disabled', false);

		Object.keys(chosen_accounts).forEach(function (key) {
			html.push(`<li>${chosen_accounts[key]['account']}, ${chosen_accounts[key]['onwer']}</li>`);
		});
		$('.card-title-chosen').html('Please review your chosen accounts for a 30 Day Extension:');
		$('.card-text-chosen').html('The Previous button will allow you to go back and make changes to your chosen accounts.');
		$('.sub-chosen').html(`The ${chosen_accounts.length} chosen account${plural} above will be emailed to you upon submission of this form.`);
		$('.checked-chosen').html(`<div class='list-chosen overflow-auto'><ol>${html.join('')}</ol></div>`);

	} else {

		$('#inputFilerName').attr('disabled', true);
		$('#inputEmail').attr('disabled', true);

		$('.card-title-chosen').html('You have not chosen any accounts for an extension:');
		$('.sub-chosen').html('');
		$('.card-text-chosen').html('The Previous button will allow you to go back to add accounts.');
		$('.checked-chosen').html(`<div class='list-chosen overflow-auto'></div>`);

	}
	return chosen_accounts.length > 0 ? true : false;
}

function getChecked() {
	let data = [];
	try {
		let table = $('#tppAccounts').DataTable();
		data = table.rows(function (idx, data, node) {
			return $(node).find('.dt-checkboxes:input[type="checkbox"]').prop('checked');
		}).data().toArray();

	} catch (error) {
		consoleErrorIfTestMode(error);
	}
	return data;
}

function fixStepIndicator(n) {
	let i, x = document.getElementsByClassName('step');
	for (i = 0; i < x.length; i++) {
		x[i].className = x[i].className.replace(' active', '');
	}
	x[n].className += ' active';
}

function debounced(delay, fn) {
	let timerId;
	return function (...args) {
		if (timerId) {
			clearTimeout(timerId);
			n = 0;
		}
		timerId = setTimeout(() => {
			fn(...args);
			timerId = null;
		}, delay);
	}
}

function runQuery(event) {
	try {
		if (event.target.value.length >= 3) {
			lookupAccount(event.target.value);
		} else {
			$('#dgData').remove();
		}
	} catch (error) {
		consoleErrorIfTestMode(error);
	}
}

function addLookupListenter() {
	const el = document.getElementById('lookup_account');
	if (el)
		el.addEventListener('input', debounced(300, runQuery));
}

function recaptchaValid() {
	let checked = getChecked();
	if (checked.length > 0) {
		setFormStateValid();
	}
}

function setFormStateValid() {
	$('#btnSubmit').attr('disabled', false);
	$('#btnSubmit').removeClass('btn-secondary');
	$('#btnSubmit').addClass('btn-primary');
}

function setFormStateInValid() {
	$('#btnSubmit').attr('disabled', true);
	$('#btnSubmit').addClass('btn-secondary');
	$('#btnSubmit').removeClass('btn-primary');
}

function checkEmail() {
	return new Promise(function (resolve, reject) {
		let email = document.getElementById('inputEmail');
		if (!email?.value.length > 0) resolve(false);

		let options = {
			type: 'email_domain',
			data: email.value
		};
		let json = JSON.stringify(options);

		$.ajax({
			url: paoDetails.context.child_uri + '/models/pao-model-validator.php',
			type: 'POST',
			data: { 'Request': json },
			dataType: 'json',
			cache: false,
			timeout: 10000,
			error: function (xhr, ajaxOptions, thrownError) {
				let err = (!xhr.responseText === 'undefined' ? xhr.responseText + ', ' : '') + thrownError;
				consoleErrorIfTestMode(err);
				resolve(false);
			},
			success: function (data) {
				if (data === true) {
					email.setCustomValidity('');
					setFormStateValid();
					resolve(true);
				} else {
					if (email.value.includes('@')) {
						let sp = email.value.split('@');
						if (sp.length > 0) {
							email.setCustomValidity(`Please enter a valid email address, ${email.value} is incomplete.`);
						} else {
							email.setCustomValidity(`Please enter a part following '@'. ${email.value} is incomplete.`);
						}
					}
					email.reportValidity();
					resolve(false);
				}
			}
		}); 
	});
}